module.exports = __webpack_public_path__ + "static/media/sparkles.11302174.svg";